import React from 'react'

import { IToolHandler } from '../types'

export type IToolPopover = React.FunctionComponent<{ onSelect?: IToolHandler }>

export enum Tools {
  emoji = 'emoji',
  vars = 'vars',
  smartLinks = 'smart_links',
  aiContentGenerator = 'ai_content_generator',
}

export enum ToolbarModes {
  DISABLED = 'disabled',
  RICHTEXT = 'richtext',
}
